import angular from 'angular';

angular.module('cloudX').directive('myDate', function() {
  return function(scope, element) {
    element.bind('click', function() {
      alert('change on' + element);
    });
  };
});
